<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('EditMonthlyWorkingHours') | ToUppercase">
                <small>{{$t('Date') |ToUppercase}}</small><br>
                <datepicker v-model="date"></datepicker>

                <vs-upload automatic :action="'/api/excel/monthlyWorkingHours/' + monthlyWorkingHoursId" :text="$t('UploadExcel')" limit="1" fileName="file" @on-success="successUpload" @on-error="errorUpload"/>

                <div class="mt-6">
                    <vs-button class="mr-2" @click="editMonthlyWorkingHours()">{{ $t("Edit") | ToUppercase }}</vs-button>
                    <vs-button @click="$router.go(-1)">{{ $t("Back") | ToUppercase }}</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                date: null,
                monthlyWorkingHoursId: 0,
            };
        },
        methods: {
            updateMonthlyWorkingHours() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/monthly-working-hours/' + this.$route.params.monthly_working_hours_id)
                .then(function (response) {
                    thisIns.monthlyWorkingHoursId = response.data.id;
                    thisIns.date = response.data.date;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju mesečnih opravljenih delovnih ur.",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            editMonthlyWorkingHours() {
                this.$vs.loading();
                const thisIns = this;
                var dateForRequest = new Date(this.date.getFullYear(), this.date.getMonth(), 2, 0, 0, 0)

                this.$http.put("/monthly-working-hours/", {
                    id: thisIns.monthlyWorkingHoursId,
                    date: dateForRequest,
                }).then(function () {
                    thisIns.$vs.notify({
                        text: "Mesečne opravljene delovne ure shranjene",
                        color: "success",
                    });
                    thisIns.$router.push('/monthly-working-hours/all');
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri shranjevanju",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            successUpload(response) {
                this.monthlyWorkingHoursId = parseInt(response.target.responseText);
                this.$vs.notify({
                    color:'success',
                    text:'Excel uspečno shranjen'
                })
            },
            errorUpload(response) {
                this.$vs.notify({
                    color:'danger',
                    text: response.target.responseText
                })
            }
        },
        created() {
            this.updateMonthlyWorkingHours();
        },
    };
</script>